// extracted by mini-css-extract-plugin
export default {"root":"PlasmicProjectpage_root__g9jcO","navbar":"PlasmicProjectpage_navbar__1d3wy","canvasView":"PlasmicProjectpage_canvasView__UFW7h"};